import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, input, Input, OnChanges, OnInit, Optional, Output, PLATFORM_ID, Renderer2, signal, SimpleChanges } from '@angular/core';
import { MEDIA_TOKEN } from '../../../../../tockens';
import { MediaService } from '@app/services/media.service';
import { ConnectedPosition } from '@angular/cdk/overlay';

interface Item {
    name: string;
    code: string;
};

@Component({
    selector: 'clever-selectionlist',
    templateUrl: './selectionlist.component.html',
    styleUrls: ['./selectionlist.component.scss'],
    standalone: false
})
export class SelectionlistComponent implements OnInit, OnChanges {
    @Input() title: string = '';
    @Input() icon: string = '';
    @Input() currentItem: string = '';
    @Input() beliebig: boolean = true;
    @Input() list: Item[] = [];
    @Output() triggerChange: EventEmitter<Item> = new EventEmitter();

    mode = input<string>('');
    isBrowser = signal<boolean>(false);
    showModal = signal<boolean>(false);

    zielText = signal<string>('Beliebig');

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];

    constructor(
        protected mediaService: MediaService,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.currentItem?.length > 0) {
            this.zielText.set(this.currentItem);
        } else {
            this.zielText.set(this.title);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['list']?.isFirstChange() && changes['list']?.currentValue) {
            this.list = changes['list'].currentValue;
        }
        if (!changes['currentItem']?.isFirstChange() && changes['currentItem']?.currentValue) {
            this.currentItem = changes['currentItem'].currentValue;
            this.zielText.set(this.currentItem);
        }
        this.cdr.detectChanges();
    }

    openModal() {
        this.showModal.set(true);
    }

    openModalMobile() {
        this.showModal.set(true);
    }

    closeModal() {
        this.showModal.set(false);
        this.cdr.detectChanges();
    }

    closeModalMobile() {
        this.showModal.set(false);
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    selectValue(item) {
        if (item) {
            this.zielText.set(item.name);
        } else {
            this.zielText.set(this.title);
        }
        this.triggerChange.emit(item);
        this.currentItem = item;
        this.closeModal();
    }
}
